import { apiClient } from '@/services';

export const VidikatService = {
  getCarServiceIFrame() {
    return apiClient.get('/vidikat/shop');
  },
};